import { useContext, useEffect, useState } from 'react'
import "./style.scss"
import Input from '../../Input';
import { AuthContext } from '../../../context/auth';
import { addRoleApi, updateRoleApi, updatePermissionApi} from '../../../api';
import { permissionsData } from '../../../utils/permissions';
import { Checkbox } from '../../Checkbox'

const Index = ({ setOpenRoleModal, selectedRole, setSelectedRole, fetchRoles, setDeleteRoleModal, existingMetadata }) => {
  const { setNotification, setIsLoading, isLoading } = useContext(AuthContext)
  const [name, setName] = useState('')
  const [permissions, setPermissions] = useState([])

  const initialPermissions = (data, existingMetadata = {}) => {
    return data.map(category => {
      const actions = category.actions.map(action => {
        const checked = action.routes.every(({ route, method }) =>
          existingMetadata?.[route]?.[method] === true
        );

        return { ...action, checked };
      });

      return {
        category: category.category,
        actions
      };
    });
  }


  useEffect(() => {
    const processed = initialPermissions(permissionsData, existingMetadata);
    setPermissions(processed);
    setName(selectedRole?.name || '');
  }, [existingMetadata]);

  const togglePermission = (categoryName, label) => {
    setPermissions(prev =>
      prev.map(category =>
        category.category !== categoryName
          ? category
          : {
            ...category,
            actions: category.actions.map(action =>
              action.label === label && !action.disabled
                ? { ...action, checked: !action.checked }
                : action
            )
          }
      )
    );
  };

  const toggleSelectAllCategory = (categoryName) => {
    setPermissions(prev =>
      prev.map(category => {
        if (category.category !== categoryName) return category;

        const allChecked = category.actions.every(action => action.checked || action.disabled);

        return {
          ...category,
          actions: category.actions.map(action =>
            action.disabled
              ? action
              : { ...action, checked: !allChecked }
          )
        };
      })
    );
  };

  const toggleGlobalSelectAll = () => {
    const allChecked = permissions.every(category =>
      category.actions.every(action => action.checked || action.disabled)
    );

    setPermissions(prev =>
      prev.map(category => ({
        ...category,
        actions: category.actions.map(action =>
          action.disabled ? action : { ...action, checked: !allChecked }
        )
      }))
    );
  };

  const buildMetadataFromPermissions = () => {
    const metadata = {};

    permissions.forEach(category => {
      category.actions.forEach(action => {
        if (!action.checked) return;

        action.routes.forEach(({ route, method }) => {
          if (!metadata[route]) metadata[route] = {};
          metadata[route][method] = true;
        });
      });
    });

    return metadata;
  };

  const allSelected = permissions.every(category =>
    category.actions.every(action => action.checked || action.disabled)
  );



 const isDisabled = () => {
  const noPermissionsChecked = !permissions.some(category =>
    category.actions.some(action => action.checked)
  );

  return isLoading || !name?.trim() || noPermissionsChecked;
};


  const editRole = () => {
    setIsLoading(true)
    const metadata = buildMetadataFromPermissions();
    const role = {
      name: name,
      metadata
    };
    updatePermissionApi(selectedRole.permissions[0]?.id, role).then(() => {
    updateRoleApi(selectedRole.id, {
      name
    }).then(() => {
        fetchRoles()
        setOpenRoleModal(false)
        setSelectedRole(null)
        setNotification({
          message: "Role Updated Successfully.",
          type: "update"
        })
        setIsLoading(false)
    }).finally(() => setIsLoading(false))
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: "Something went wrong.",
        type: "red"
      })
    })
  }

   const addRole = () => {
    setIsLoading(true)
    const metadata = buildMetadataFromPermissions();
    const role = {
      name: name,
      metadata
    };
    addRoleApi({
      name,
      permissions: [role]
    }).then(() => {
        fetchRoles()
        setOpenRoleModal(false)
        setSelectedRole(null)
        setNotification({
          message: "Role Created Successfully.",
          type: "update"
        })
        setIsLoading(false)
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: "Something went wrong.",
        type: "red"
      })
    })
  }

  return (
    <div className="small-modal-wrapper">
      <div className="role-modal-content">
        <span className='close' onClick={() => {
          setOpenRoleModal(false)
          setSelectedRole(null)
        }}><i className="fas fa-times"></i></span>
        {selectedRole && <span className='delete' onClick={() => {
          setDeleteRoleModal(true)
        }}>
          <i className="fal fa-trash-alt"></i></span>}
        <h2>{selectedRole ? 'Edit Role' : 'Add New Role'}</h2>
        <div className="form-container">
          <div className='row'>
            <div className="input-container">
              <label htmlFor="role name">Role Name<span>*</span></label>
              <Input type='text' placeholder='Role Name' value={name} onChange={e => setName(e.target.value)} />
            </div>
          </div>
          <div>
            <div className="permissions-container">
              <div className='permission-header'>
              <Checkbox
                style={{ fontSize: '16px', fontWeight: 500 }}
                label={'Select All Permissions'}
                checked={allSelected}
                onChange={toggleGlobalSelectAll}
              />
              </div>
              {
                permissions.map((category, index) => {
                  const allChecked = category.actions.every(action => action.checked || action.disabled);
                  return (
                    <div className='permissions' key={index}>
                      <h3>{category.category}</h3>
                      <Checkbox
                        style={{ fontSize: '16px', fontWeight: 500 }}
                        label={'Select All'}
                        checked={allChecked}
                        onChange={() => toggleSelectAllCategory(category.category)}
                      />
                      {category.actions
                        .map(action => (
                          <div className='permission' key={action.label}>
                            <Checkbox
                              style={{ fontSize: '16px', fontWeight: 500 }}
                              label={action.label}
                              checked={action.checked}
                              onChange={() => togglePermission(category.category, action.label)}
                            />
                          </div>
                        ))}
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
        <div className='row'>
          <button className='btn transparent'
            onClick={() => setOpenRoleModal(false)
            }>Discard
          </button>
          <button className='btn add-btn'
            disabled={isDisabled()}
            onClick={() => {
              if (selectedRole) {
                editRole()
              } else {
                addRole()
              }
            }}>{selectedRole ? 'Save Changes' : 'Add New Role'}</button>
        </div>
      </div>
    </div>
  )
}

export default Index